const BACK_URL = process.env.REACT_APP_BACKEND_URL

const ADDITIONAL_MATERIALS = `${BACK_URL}additionalmaterials/`

const FILES = `${BACK_URL}files`

export default { ADDITIONAL_MATERIALS, FILES }
